import { useMemo as I, useState as h, useCallback as m, useRef as d, useEffect as P } from "react";
import { createBreakpoint as L } from "react-use";
import { useTranslation as E } from "@cronika/locales";
import { clearAllBodyScrollLocks as T, disableBodyScroll as b } from "body-scroll-lock";
var R = /* @__PURE__ */ ((t) => (t.chip = "chip", t.radioChip = "radio_chip", t.range = "range", t.select = "select", t.dateRange = "date_range", t.input = "input", t))(R || {});
const k = ({ config: t }) => I(() => {
  const n = [];
  return t.forEach((e) => {
    e.filters.forEach((c) => {
      if (c.type === R.range) {
        n.push(c.alias[0]), n.push(c.alias[1]);
        return;
      }
      if (c.type === R.dateRange) {
        n.push(c.alias[0]), n.push(c.alias[1]);
        return;
      }
      n.push(c.alias);
    });
  }), n;
}, []);
var y = { screens: { sm: "40rem", md: "48rem", lg: "64rem", xl: "80rem", "2xl": "96rem" } };
const i = (t) => Number.parseInt(t.replace(/px$/, ""), 10), p = y.screens, x = {
  /** Mobile phones - 0px and up */
  phone: 0,
  /** Tablets - 768px and up (maps to Tailwind's md) */
  tablet: i(p.md),
  /** Laptops - 1024px and up (maps to Tailwind's lg) */
  laptop: i(p.lg),
  /** Desktop - 1280px and up (maps to Tailwind's xl) */
  desktop: i(p.xl)
}, D = {
  /** Extra small - 0px and up */
  xs: 0,
  /** Small - 640px and up */
  sm: i(p.sm),
  /** Medium - 768px and up */
  md: i(p.md),
  /** Large - 1024px and up */
  lg: i(p.lg),
  /** Extra large - 1280px and up */
  xl: i(p.xl),
  /** 2x Extra large - 1536px and up */
  "2xl": i(p["2xl"])
}, A = L(
  x
), U = L(
  D
), G = () => {
  const t = A();
  return {
    /**
     * Current breakpoint name
     * @type {'phone' | 'tablet' | 'laptop' | 'desktop'}
     */
    breakpoint: t,
    /**
     * True when current breakpoint is 'phone'
     * Useful for phone-specific layouts and features
     */
    isPhone: t === "phone",
    /**
     * True when current breakpoint is 'tablet'
     * Useful for tablet-specific layouts and features
     */
    isTablet: t === "tablet",
    /**
     * True when current breakpoint is 'laptop'
     * Useful for laptop-specific layouts and features
     */
    isLaptop: t === "laptop",
    /**
     * True when current breakpoint is 'desktop'
     * Useful for desktop-specific layouts and features
     */
    isDesktop: t === "desktop",
    /**
     * True when current breakpoint is 'phone' or 'tablet'
     * Useful for mobile-first responsive design patterns
     */
    isMobile: t === "phone" || t === "tablet",
    /**
     * True when current breakpoint is 'laptop' or 'desktop'
     * Useful for desktop-first responsive design patterns
     */
    isDesktopOrLarger: t === "laptop" || t === "desktop"
  };
}, V = (t) => k({ config: t }).reduce(
  (n, e) => ({ ...n, [e]: "" }),
  {}
), g = (t, r) => {
  if (!t || typeof t != "object") return;
  const n = r.split(".");
  let e = t;
  for (const c of n) {
    if (e == null || typeof e != "object")
      return;
    e = e[c];
  }
  return e;
}, B = (t, r) => typeof t == "string" ? t.startsWith("validation:") ? r(t) : t : Array.isArray(t) && t.length > 0 ? B(t[0], r) : typeof t == "object" && t !== null ? String(t) : t || "", N = (t = "validation") => {
  const { t: r } = E(t), n = (s) => B(s, r), e = (s, o) => {
    const a = g(s.touched, o), u = g(s.errors, o);
    return a && u ? n(u) : "";
  }, c = (s, o) => !!(g(s.touched, o) && g(s.errors, o));
  return {
    translateValidationError: n,
    getFieldError: e,
    isFieldInvalid: c,
    getFieldProps: (s, o) => ({
      ...s.getFieldProps(o),
      isInvalid: c(s, o),
      errorMessage: e(s, o)
    })
  };
};
function $(t, r) {
  const [n, e] = h(() => {
    try {
      const s = localStorage.getItem(t);
      return s === null ? r : JSON.parse(s);
    } catch {
      return r;
    }
  }), c = m(
    (s) => {
      e((o) => {
        const a = s instanceof Function ? s(o) : s;
        try {
          localStorage.setItem(t, JSON.stringify(a));
        } catch {
        }
        return a;
      });
    },
    [t]
  ), l = m(() => {
    try {
      localStorage.removeItem(t);
    } catch {
    }
    e(r);
  }, [t, r]);
  return [n, c, l];
}
const w = (t, r = {}) => {
  const {
    interval: n = 2e3,
    enabled: e = !0,
    maxAttempts: c = 0
  } = r, l = d(null), s = d(0), o = d(!1), a = d(t);
  a.current = t;
  const u = m(() => {
    o.current = !1, l.current && (clearTimeout(l.current), l.current = null);
  }, []), f = m(() => {
    if (o.current) return;
    o.current = !0, s.current = 0;
    const S = () => {
      if (o.current) {
        if (c > 0 && s.current >= c) {
          u();
          return;
        }
        s.current += 1, a.current(), o.current && (l.current = setTimeout(S, n));
      }
    };
    S();
  }, [n, c, u]);
  return P(() => (e && f(), u), [e, f, u]), {
    attempts: s.current,
    isPolling: o.current,
    stop: u,
    start: f
  };
}, v = {
  reserveScrollBarGap: !0
}, H = () => {
  const t = d(null), r = d(!0);
  return { setScrollLock: (e) => {
    if (!e && !r.current) {
      setTimeout(() => T(), 100);
      return;
    }
    if (t.current)
      return e && b(t.current, v), r.current = !1, () => {
        t.current && b(t.current, v);
      };
  }, scrollRef: t };
}, K = (t = {}) => {
  const {
    initialField: r = null,
    initialDirection: n = r ? "desc" : null,
    allowClear: e = !0,
    fieldMap: c
  } = t, [l, s] = h(r), [o, a] = h(n), u = I(() => !l || !o ? {} : {
    sortBy: c?.[l] ?? l,
    sortDir: o
  }, [c, o, l]), f = m(
    (S) => {
      if (l === S) {
        if (o === "desc") {
          a("asc");
          return;
        }
        if (o === "asc") {
          if (e) {
            s(null), a(null);
            return;
          }
          a("desc");
          return;
        }
      }
      s(S), a("desc");
    },
    [e, o, l]
  );
  return {
    sortField: l,
    sortDirection: o,
    sortParams: u,
    handleSort: f,
    setSortField: s,
    setSortDirection: a
  };
}, _ = ({
  e: t,
  t: r,
  prefix: n,
  includeAll: e = !1
}) => {
  const c = Object.values(t).map((l) => ({
    value: l,
    label: r(`${n}.${l}`)
  }));
  return e && c.unshift({
    value: null,
    label: r(`${n}.all`)
  }), c;
}, j = (t, r) => {
  const n = {};
  for (const e in r)
    r[e] !== t[e] && (n[e] = r[e]);
  return n;
}, J = [
  "AU",
  // Australia
  "AT",
  // Austria
  "BE",
  // Belgium
  "BG",
  // Bulgaria
  "GB",
  // United Kingdom
  "HU",
  // Hungary
  "DE",
  // Germany
  "GR",
  // Greece
  "DK",
  // Denmark
  "IL",
  // Israel
  "IR",
  // Iran
  "IE",
  // Ireland
  "IS",
  // Iceland
  "ES",
  // Spain
  "IT",
  // Italy
  "YE",
  // Yemen
  "CA",
  // Canada
  "LV",
  // Latvia
  "LT",
  // Lithuania
  "LI",
  // Liechtenstein
  "LU",
  // Luxembourg
  "MT",
  // Malta
  "MM",
  // Myanmar
  "NL",
  // Netherlands
  "NZ",
  // New Zealand
  "NO",
  // Norway
  "PL",
  // Poland
  "PT",
  // Portugal
  "PR",
  // Puerto Rico
  "CY",
  // Cyprus
  "RO",
  // Romania
  "KP",
  // North Korea
  "SG",
  // Singapore
  "SK",
  // Slovakia
  "SI",
  // Slovenia
  "SD",
  // Sudan
  "US",
  // United States
  "FI",
  // Finland
  "FR",
  // France
  "HR",
  // Croatia
  "EE",
  // Estonia
  "SE",
  // Sweden
  "CH",
  // Switzerland
  "SS"
  // South Sudan
];
export {
  R as EFilterType,
  J as RESTRICTED_COUNTRIES,
  x as breakpoints,
  j as buildUpdatePayload,
  _ as enumToOptions,
  D as tailwindBreakpoints,
  k as useAllAlias,
  A as useBreakpoint,
  V as useClearFilters,
  N as useFormValidation,
  $ as useLocalStorage,
  w as usePolling,
  G as useResponsive,
  H as useScrollLock,
  K as useServerSort,
  U as useTailwindBreakpoint
};
